<template>
  <div class="container">
    <div class="header">
      <div class="calss-info">{{schooleVal.text}}-{{subject.StudentYearName+subject.StudentGradeName+subject.StudentOrganizationName}}</div>
      <div class="sub-info">
        <div>{{subject.SubjectName}}</div>
        <div class="line" v-if="subject.TeacherName"></div>
        <div>{{subject.TeacherName}}</div>
        <div class="line" v-if="subject.HouseName"></div>
        <div>{{subject.HouseName}}</div>
      </div>
      <div class="time-info" v-if="subject.StartTime">{{subject.StartTime}}-{{subject.EndTime}}</div>
    </div>
    <div class="s-content">
      <div class="top-s">
        <div class="s-1">选课学生名单</div>
        <div class="s-2">(共{{subject.StudentList.length}}人)</div>
      </div>
      <div class="s-list">
        <div class="s-info" v-for="item in subject.StudentList" :key="item.StudentId">
          <img src="@/assets/csmsTimeTable/head-picture.png" />
          <div>
            <div class="name">{{item.StudentName}}</div>
            <div class="card">{{item.StudentNumber}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      subject:'',
      schooleVal:''
    };
  },
  created() {
    this.schooleVal=this.$route.query.schooleVal
    this.subject=this.$route.query.subject
  },
  mounted() {},
  methods: {

  }
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
  background: #fff;
  height: calc(100vh - 90px);
  .header {
    height: 386px;
    background-image: url("../../../../assets/csmsTimeTable/my-schedule-bg1.png");
    background-size: 100%;
    padding: 0 44px;
    .calss-info{
      font-size: 40px;
      font-weight: 500;
      color: #FFFFFF;
      padding: 50px 0 32px;
    }
    .sub-info{
      display: flex;
      align-items: center;
      color: #FFFFFF;
      font-size: 30px;
      margin-bottom: 16px;
      .line{
        width: 1px;
        height: 26px;
        background-color: #fff;
        margin: 0 20px;
      }
    }
    .time-info{
      color: #FFFFFF;
      font-size: 30px;
    }
  }
  .s-content{
    position: relative;
    top: -80px;
    background: #fff;
    border-radius: 66px 66px 0px 0px;
    height: calc(100% - 306px);
    .top-s{
      padding: 0 44px;
      height: 120px;
      display: flex;
      align-items: center;
      .s-1{
        font-weight: 500;
        color: #333333;
        font-size: 32px;
      }
      .s-2{
        font-weight: 400;
        color: #333333;
        font-size: 24px;
      }
    }
    .s-list{
      height: calc(100% - 120px);
      overflow: auto;
      padding: 0 22px;
      .s-info{
        padding: 0 22px;
        height: 144px;
        border-bottom: 1px solid #EEEEEE;
        display: flex;
        align-items: center;
        img{
          width: 100px;
          height: 100px;
          margin-right: 24px;
        }
        .name{
          color: rgba(0,0,0,0.85);
          font-size: 28px;
          margin-bottom: 24px;
        }
        .card{
          color: #999999;
          font-size: 28px;
        }
      }
    }
  }
}
</style>
